import { API_BASE_URL } from "src/config/api";
import React, { useState } from 'react';
import {
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Grid,
  CircularProgress,
} from '@mui/material';
import styled from 'styled-components';
import axios from 'axios';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';

const PageContainer = styled(Container)`
  padding: 20px;
`;

const NewsForm = styled(Paper)`
  padding: 20px;
`;

const NewsTitle = styled(Typography)`
  font-size: 24px;
  margin-bottom: 10px;
`;

const NewsUpdatePage = (props) => {
  NewsUpdatePage.propTypes = {
    closeForm: PropTypes.func,
    reloadData: PropTypes.func,
  };

  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const token = localStorage.getItem('token');

  const [errors, setErrors] = useState({ title: '', content: '' });

  const handleTitleChange = (event) => {
    setTitle(event.target.value);
    setErrors((prev) => ({ ...prev, title: '' }));
  };

  const handleContentChange = (event) => {
    setContent(event.target.value);
    setErrors((prev) => ({ ...prev, content: '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let formValid = true;
    const newErrors = { title: '', content: '' };

    if (!title.trim()) {
      newErrors.title = 'Title is required';
      formValid = false;
    }

    if (!content.trim()) {
      newErrors.content = 'Content is required';
      formValid = false;
    }

    setErrors(newErrors);

    if (!formValid) {
      toast.error('Please fill in all required fields.');
      return;
    }

    setIsLoading(true);

    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const newsData = {
        newsTitle: title,
        newsDescription: content,
      };

      const response = await axios.post(
        `${API_BASE_URL}/addNewsUpdateByAdmin`,
        newsData,
        config
      );

      toast.success(response.data.message);
      props.closeForm();
      props.reloadData();
    } catch (error) {
      console.error('Error submitting form data:', error);

      if (error.response) {
        toast.error(error.response.data.message);
      } else {
        toast.error('Server Not Found');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PageContainer>
      <NewsForm elevation={3}>
        <NewsTitle variant="h5">Add News Update</NewsTitle>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Title"
                variant="outlined"
                fullWidth
                value={title}
                onChange={handleTitleChange}
                error={!!errors.title}
                helperText={errors.title}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Content"
                variant="outlined"
                multiline
                rows={4}
                fullWidth
                value={content}
                onChange={handleContentChange}
                error={!!errors.content}
                helperText={errors.content}
                required
              />
            </Grid>
          </Grid>
          <br />
          {isLoading ? (
            <CircularProgress />
          ) : (
            <Button variant="contained" color="primary" type="submit">
              Add News
            </Button>
          )}
        </form>
      </NewsForm>
    </PageContainer>
  );
};

export default NewsUpdatePage;
